var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("FormSubmitPopup", {
    attrs: {
      title: _vm.$t("resolveCase"),
      rightMethod: _vm.onSubmitted,
      rightButtonText: _vm.$t("submit"),
      medium: ""
    },
    on: {
      popupClose: function($event) {
        return _vm.$emit("input", false)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "input",
        fn: function() {
          return [
            _c(
              "v-container",
              [
                _c(
                  "v-layout",
                  { attrs: { row: "", wrap: "", "align-baseline": "" } },
                  [
                    _c(
                      "v-flex",
                      { attrs: { xs12: "", sm6: "" } },
                      [
                        _c("v-combobox", {
                          staticClass: "required_field",
                          attrs: {
                            label: _vm.$t("resolution"),
                            multiple: "",
                            chips: "",
                            items: _vm.types,
                            rules: [_vm.fieldIsRequired("resolve type")]
                          },
                          model: {
                            value: _vm.resolveTypes,
                            callback: function($$v) {
                              _vm.resolveTypes = $$v
                            },
                            expression: "resolveTypes"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      {
                        staticStyle: { position: "relative", top: "5px" },
                        attrs: { xs12: "", md6: "" }
                      },
                      [
                        _c("v-text-field", {
                          staticClass: "required_field",
                          attrs: {
                            label: _vm.$t("amount"),
                            rules: [
                              _vm.fieldIsRequired("Amount"),
                              _vm.fieldIsNumber("amount")
                            ],
                            hint: _vm.$t("caseAmountHint"),
                            "persistent-hint": ""
                          },
                          model: {
                            value: _vm.amount,
                            callback: function($$v) {
                              _vm.amount = _vm._n($$v)
                            },
                            expression: "amount"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("v-textarea", {
                  attrs: {
                    outline: "",
                    label: _vm.$t("details"),
                    counter: 500,
                    "auto-grow": "",
                    rows: "3"
                  },
                  model: {
                    value: _vm.details,
                    callback: function($$v) {
                      _vm.details = $$v
                    },
                    expression: "details"
                  }
                }),
                _vm._v(" "),
                _c("v-text-field", {
                  attrs: { label: _vm.$t("keywords") },
                  model: {
                    value: _vm.keywords,
                    callback: function($$v) {
                      _vm.keywords = $$v
                    },
                    expression: "keywords"
                  }
                })
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ]),
    model: {
      value: _vm.value,
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1c09de0f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c09de0f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SupportResolvePopup.vue
// module id = null
// module chunks = 